<template>
  <!-- DOCK -->
  <template v-if="config?.dock?.id != undefined">
    <DockSmallQuickStatus :config="config" />
  </template>

  <!-- RC+ -->
  <template v-if="config?.rcPlus?.id != undefined">
    <RcPlusSmallQuickStatus :config="config" />
  </template>

  <!-- DRONE -->
  <template v-if="config?.drone?.id != undefined">
    <DroneSmallQuickStatus :config="config" />
  </template>
</template>

<script>
import DockSmallQuickStatus from "@/app/popup/partial/Dock/DockSmallQuickStatus.vue";
import RcPlusSmallQuickStatus from "@/app/popup/partial/Rc+/RcPlusSmallQuickStatus.vue";
import DroneSmallQuickStatus from "@/app/popup/partial/Drone/DroneSmallQuickStatus.vue";

export default {
  name: "QuickStatus",
  props: {
    config: Object,
  },
  components: {
    DockSmallQuickStatus,
    RcPlusSmallQuickStatus,
    DroneSmallQuickStatus,
  },
};
</script>
